import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import {
  checkedIcon,
  expiredIcon,
  hourGlassIcon,
  uncertaintyIcon,
} from '@/assets/images';
import InviteStatuses from '@/constants/orgs/InviteStatuses';

const ICON_STATUS_MAPPER = {
  [InviteStatuses.PENDING]: hourGlassIcon,
  [InviteStatuses.SENT]: hourGlassIcon,
  [InviteStatuses.REJECTED]: uncertaintyIcon,
  [InviteStatuses.JOINED]: checkedIcon,
  [InviteStatuses.CANCELLED]: expiredIcon,
};

function TeamMemberInviteStatusCell({ value: status }) {
  return (
    <Tooltip title={status.charAt(0).toUpperCase() + status.slice(1)}>
      <img
        className="w-[16px]"
        alt={`${status} icon`}
        data-testid={`${status}-icon`}
        src={ICON_STATUS_MAPPER[status]}
      />
    </Tooltip>
  );
}

TeamMemberInviteStatusCell.propTypes = {
  value: PropTypes.string,
};

TeamMemberInviteStatusCell.defaultProps = {
  value: '',
};

export default TeamMemberInviteStatusCell;
